import { getAddress } from "viem"

export const vaults = new Map([
  [
    getAddress("0x6c718a70239fA548c0bD268fE88F37EBE8b6E2ea"),
    {
      name: "Re7 Labs WAVAX",
      description: "Component of the Re7 Labs Avalanche Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xABA9d2D4b6B93C3dc8976D8eb0690CCA56431FE4"),
    {
      name: "Re7 Labs USDT",
      description: "Component of the Re7 Labs Avalanche Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x39dE0f00189306062D79eDEC6DcA5bb6bFd108f9"),
    {
      name: "Re7 Labs USDC",
      description: "Component of the Re7 Labs Avalanche Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x4eC5B9a4d4FD9E35d4f881D35AAB9877bfdA5803"),
    {
      name: "Re7 Labs BTC.b",
      description: "Component of the Re7 Labs Avalanche Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xB1Ec13C66fdb12205C6C82c392a5A3b393207388"),
    {
      name: "Re7 Labs SolvBTC.BBN",
      description: "Component of the Re7 Labs Avalanche Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xADaFfbEBEEAd3D3e042C3e7c146F61FE62728e6c"),
    {
      name: "Re7 Labs SolvBTC",
      description: "Component of the Re7 Labs Avalanche Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x7485484Dab196C615AE21453C3ABd732977562f2"),
    {
      name: "Re7 Labs WETH.e",
      description: "Component of the Re7 Labs Avalanche Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x38a559c2b6eF3fF7Cdc40a800D6351a2B70b2243"),
    {
      name: "Re7 Labs sAVAX",
      description: "Component of the Re7 Labs Avalanche Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xb52a9c3aea75939a78287F81b53A9e965e058eec"),
    {
      name: "Re7 Labs ggAVAX",
      description: "Component of the Re7 Labs Avalanche Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x2137568666f12fc5A026f5430Ae7194F1C1362aB"),
    {
      name: "Re7 Labs AUSD",
      description: "Component of the Re7 Labs Avalanche Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x27807C61F6b376754b7ce208AA8b17D2DA56d582"),
    {
      name: "Re7 Labs avUSD",
      description: "Component of the Re7 Labs Avalanche Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x72F92a966f1874f74e1b601BEe7CF57031B53A03"),
    {
      name: "Re7 Labs savUSD",
      description: "Component of the Re7 Labs Avalanche Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xA06e66646292b2C2042495B955fe07c4036f6635"),
    {
      name: "Re7 Labs sBUIDL",
      description: "Component of the Re7 Labs Avalanche Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xA45189636c04388ADBb4D865100DD155e55682EC"),
    {
      name: "Re7 Labs deUSD",
      description: "Component of the Re7 Labs Avalanche Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xFECebF56f150A68dDd197c3a6101da35C46693Ac"),
    {
      name: "Re7 Labs sdeUSD",
      description: "Component of the Re7 Labs Avalanche Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x3C69C59075269cAf0571F9d2eFC359bcBD4e29bB"),
    {
      name: "Re7 Labs yUTY",
      description: "Component of the Re7 Labs Avalanche Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x9298D274A31803bb73c2A5E5EcDd101c581C4AfD"),
    {
      name: "Re7 Labs UTY",
      description: "Component of the Re7 Labs Avalanche Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xAF0d176Daa761d105E688EE70060b1FF9540e0cb"),
    {
      name: "Re7 Labs upAUSD",
      description: "Component of the Re7 Labs Avalanche Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xb4bc9D19D827893e0a21c2F4E7B527A5f8525C3f"),
    {
      name: "Re7 Labs upAVAX",
      description: "Component of the Re7 Labs Avalanche Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x9B1DC432150cEF8f129A9eEa3CA8364d0b06904f"),
    {
      name: "Re7 Labs sUSDe",
      description: "Component of the Re7 Labs Avalanche Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xA429273b892c2c90b1d90778f4786e6470F402eC"),
    {
      name: "MEV Capital WAVAX",
      description: "Component of the MEV Capital Avalanche Cluster",
      entity: "mev-capital",
    },
  ],
  [
    getAddress("0x1Ff8f20dFF1dA13fEdD975224b580766dbB7634e"),
    {
      name: "MEV Capital BTC.b",
      description: "Component of the MEV Capital Avalanche Cluster",
      entity: "mev-capital",
    },
  ],
  [
    getAddress("0x5cB6F04682299eB196F7d673c09a04DF68028071"),
    {
      name: "MEV Capital WETH.e",
      description: "Component of the MEV Capital Avalanche Cluster",
      entity: "mev-capital",
    },
  ],
  [
    getAddress("0x69B07dB605d0A08fbE9245c1466880AA36c8E1A7"),
    {
      name: "MEV Capital USDC",
      description: "Component of the MEV Capital Avalanche Cluster",
      entity: "mev-capital",
    },
  ],
  [
    getAddress("0x152179bfc75f780bFe5b0d3c0D3c797108fB24C3"),
    {
      name: "MEV Capital sAVAX",
      description: "Component of the MEV Capital Avalanche Cluster",
      entity: "mev-capital",
    },
  ],
  [
    getAddress("0x91bFd7192990c2A56dF4AceFf5Fe063B75b636A5"),
    {
      name: "MEV Capital ggAVAX",
      description: "Component of the MEV Capital Avalanche Cluster",
      entity: "mev-capital",
    },
  ],
  [
    getAddress("0x6fC9b3a52944A577cd8971Fd8fDE0819001bC595"),
    {
      name: "K3 Capital USDC",
      description: "Component of the K3 Capital Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0xa446938b0204Aa4055cdFEd68Ddf0E0d1BAB3E9E"),
    {
      name: "K3 Capital USDT",
      description: "Component of the K3 Capital Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x5030183B3DD0105d69D7d45595C120Fc4b542EC3"),
    {
      name: "K3 Capital savUSD",
      description: "Component of the K3 Capital Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x03ef14425CF0d7Af62Cdb8D6E0Acb0b0512aE35C"),
    {
      name: "K3 Capital WETH.e",
      description: "Component of the K3 Capital Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0xe91841F707936faf515ff6d478624A325A4f9199"),
    {
      name: "K3 Capital WAVAX",
      description: "Component of the K3 Capital Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x38eA4c0724b20B02e5fdE235F657a3aFc184f5aC"),
    {
      name: "K3 Capital ggAVAX",
      description: "Component of the K3 Capital Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x4d758aB40Abb122402F01e1ec4C71ACb06A1f620"),
    {
      name: "K3 Capital sAVAX",
      description: "Component of the K3 Capital Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x6072A6d18446278bB5a43eb747de8F61e34cB77f"),
    {
      name: "K3 Capital BTC.b",
      description: "Component of the K3 Capital Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0xe1E549C965A4A0514D9bf80161D32924b8694822"),
    {
      name: "K3 Capital deUSD",
      description: "Component of the K3 Capital Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0xb9CC370a8f19322FC4BF69Da80c6C39FF8F2dB90"),
    {
      name: "K3 Capital sdeUSD",
      description: "Component of the K3 Capital Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x902714C7661697c873C76dEC426b63B2593ecc0a"),
    {
      name: "K3 Capital UTY",
      description: "Component of the K3 Capital Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x76DE251BeE4A3B902857f6A0fCe8a320C4167E40"),
    {
      name: "K3 Capital yUTY",
      description: "Component of the K3 Capital Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x51b47B3013863c52CA28D603De3C2d7a5FEf50B9"),
    {
      name: "K3 Capital weETH",
      description: "Component of the K3 Capital Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0xa4284e26Ae6469aeE8eC38Aa9Db96fc62d6315A1"),
    {
      name: "K3 Capital EURC",
      description: "Component of the K3 Capital Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0xd058fbF3aC2E1bCa615EB127c2b94AF1b3Be11A9"),
    {
      name: "K3 Capital PT-USDe-27NOV2025",
      description: "Component of the K3 Capital Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x6E65eB6cAC41a19E0B8bb16F3b5Ad150f9124D3d"),
    {
      name: "K3 Capital wrsETH",
      description: "Component of the K3 Capital Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x82131b7601dE10a7e28d371F1b672205195E4e5D"),
    {
      name: "K3 Capital EUROP",
      description: "Component of the K3 Capital Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x8f23Da78e3F31Ab5DEb75dC3282198bed630ffde"),
    {
      name: "Keyring USDC",
      description: "Component of the Keyring Avalanche Cluster",
      entity: "keyring",
    },
  ],
  [
    getAddress("0xea534105c2ccC0582D82B285aA47A6B446383d44"),
    {
      name: "Keyring xUSDC",
      description: "Component of the Keyring Avalanche Cluster",
      entity: "keyring",
    },
  ],
  [
    getAddress("0x67E0aC01425FA296169dBB5157349e668f6B4438"),
    {
      name: "Keyring WAVAX",
      description: "Component of the Keyring Avalanche Cluster",
      entity: "keyring",
    },
  ],
  [
    getAddress("0xb032772229B2af29EaA026D1648bB9bC42bB0592"),
    {
      name: "Keyring sAVAX",
      description: "Component of the Keyring Avalanche Cluster",
      entity: "keyring",
    },
  ],
  [
    getAddress("0x5FDb07efb2DafAc9186C8A7902332ce0F4B764C6"),
    {
      name: "Keyring wETH.e",
      description: "Component of the Keyring Avalanche Cluster",
      entity: "keyring",
    },
  ],
  [
    getAddress("0x3050B75382aB718fAD92D83C5f99c7fDA1654529"),
    {
      name: "Keyring BTC.b",
      description: "Component of the Keyring Avalanche Cluster",
      entity: "keyring",
    },
  ],
  [
    getAddress("0x6De07D6Cbd0c4e8Fa93Da3d7BdaA1D1505651a1E"),
    {
      name: "Keyring sdeUSD",
      description: "Component of the Keyring Avalanche Cluster",
      entity: "keyring",
    },
  ],
  [
    getAddress("0x04293b180bf9C57eD0923C99c784Cb571f0A9Ae9"),
    {
      name: "Reservoir Labs BTC.b",
      description: "Component of the Reservoir Labs Avalanche Cluster",
      entity: "reservoir-labs",
    },
  ],
  [
    getAddress("0xA321a38b03a7218157668a724E186f3a81CF56c8"),
    {
      name: "Reservoir Labs WBTC.e",
      description: "Component of the Reservoir Labs Avalanche Cluster",
      entity: "reservoir-labs",
    },
  ],
  [
    getAddress("0x2cBb39cdC3c0bA22F857A5A8cA54DEE6D7fD04bF"),
    {
      name: "Keyring xBTC.b",
      description: "Component of the Keyring Cluster",
      entity: "keyring",
    },
  ],
  [
    getAddress("0x37ca03aD51B8ff79aAD35FadaCBA4CEDF0C3e74e"),
    {
      name: "9Summits USDC",
      description: "Component of the 9Summits Avalanche Cluster",
      entity: "9summits",
    },
  ],
  [
    getAddress("0x3F96e387eC6462DFBe9F05838943D19307dD2752"),
    {
      name: "9Summits sUSDe",
      description: "Component of the 9Summits Avalanche Cluster",
      entity: "9summits",
    },
  ],
  [
    getAddress("0xF983f92bd962A94EAc85a8c58237C1CC1cDfBBBa"),
    {
      name: "9Summits BTC.b",
      description: "Component of the 9Summits Avalanche Cluster",
      entity: "9summits",
    },
  ],
  [
    getAddress("0xbaC3983342b805E66F8756E265b3B0DdF4B685Fc"),
    {
      name: "9Summits savUSD",
      description: "Component of the 9Summits Avalanche Cluster",
      entity: "9summits",
    },
  ],
  [
    getAddress("0xf3aCc3Fc22E376fa3dD21CF883B60DDE9cf4E34f"),
    {
      name: "9Summits sAVAX",
      description: "Component of the 9Summits Avalanche Cluster",
      entity: "9summits",
    },
  ],
  [
    getAddress("0x6b640afFdE7cFa8322cA5c7F8bB7d276de3d30A3"),
    {
      name: "9Summits WETH.e",
      description: "Component of the 9Summits Avalanche Cluster",
      entity: "9summits",
    },
  ],
])
